import React, { Component } from "react"
import Svg from "../_svgs/svg"
import * as cookieHelper from "../../helpers/cookie"
import * as SelectionFactoryHelper from "../helpers/SelectionFactoryHelper"

export default class Notification extends Component {
  constructor(props) {
    super(props)

    let show = false
    if (props.modifier.includes("soldOutBanner")) {
      show = true
    } else {
      const cookie = cookieHelper.getCookie(props.version)
      if (!cookie) {
        show = true
      }
    }

    this.state = {
      show: show,
    }
  }

  componentDidMount() {
    window.addEventListener("resize", (event) => {
      this.setState({ screenWidth: event.target.screen.width })
    })
  }

  showHideContent(event) {
    let elem = event.currentTarget
    let parent = elem.parentElement
    elem.__toggle = !elem.__toggle
    if (elem.__toggle) {
      parent.style.height = parent.scrollHeight + "px"
      parent.classList.add("open")
    } else {
      parent.style.height = 70 + "px"
      parent.classList.remove("open")
    }
  }

  handleClose = (e) => {
    cookieHelper.setCookie(this.props.version, "closed")
    const target = e.currentTarget
    const banner = target.closest(".notifications")
    if (banner) {
      banner.style.display = "none"
    }
  }

  render() {
    const type = SelectionFactoryHelper.getFromSelectionFactory(this.props.type)
    const target = SelectionFactoryHelper.getFromSelectionFactory(this.props.linkTarget)
    return (
      <div
        className={`notifications ${this.props.modifier ?? ""}`}
        data-notification-version={this.props.version}
        style={{ display: this.state.show ?? false ? "block" : "none" }}
      >
        <div className={`notification js--notification ${type}`}>
          <div className="iconarea">
            <Svg iconName={"caution"} />
          </div>
          <h5>{this.props.headline}</h5>

          {window.innerWidth < 950 ? (
            <div className={`foldable show-hide`} style={{ height: "70px" }}>
              {/* <div className={`pointer`} onClick={(e) => this.showHideContent(e)}></div> */}
              <span className="arrow" onClick={(e) => this.showHideContent(e)}></span>
              <div className="maintext">
                {this.props.text}{" "}
                <a target={target} href={this.props.linkUrl}>
                  {this.props.linkText}
                </a>
              </div>
            </div>
          ) : (
            <div className="maintext">
              {this.props.text}{" "}
              <a target={target} href={this.props.linkUrl}>
                {this.props.linkText}
              </a>
            </div>
          )}

          <a className="button button--icon" onClick={(e) => this.handleClose(e)}>
            <Svg iconName={"close"} />
          </a>
        </div>
      </div>
    )
  }
}
